export default __webpack_public_path__ + "static/media/boa-yt.5df16117.svg";